import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import moment from 'moment'
import Loading from 'orionsoft-parts/lib/components/Loading'
import GoFileText from 'react-icons/lib/go/file-text'
import Button from 'orionsoft-parts/lib/components/Button'
import Actions from 'src/App/components/Actions'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import withOrganization from 'App/Decorators/withOrganization'
import MdCancel from 'react-icons/lib/md/cancel'
import MdLibraryBooks from 'react-icons/lib/md/library-books'
import TiArrowForwardOutline from 'react-icons/lib/ti/arrow-forward-outline'
import Instructions from './Instructions'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'
import contextUrl from '../../../Root/contextUrl'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'

@withOrganization
@withRouter
@withMessage
@withMutation(gql`
  mutation createFromTemplate($templateId: ID) {
    createFromTemplate(templateId: $templateId) {
      _id
    }
  }
`)
@withMutation(
  gql`
    mutation deleteTemplate($templateId: ID!) {
      deleteTemplate(templateId: $templateId) {
        success
      }
    }
  `
)

@withGraphQL(
  gql`
    query hasSiteTemplates {
      hasSiteTemplates
    }
  `
)

export default class Main extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    createFromTemplate: PropTypes.func,
    deleteTemplate: PropTypes.func,
    showMessage: PropTypes.func,
    organization: PropTypes.object,
    hasSiteTemplates: PropTypes.object
  }

  state = {
    showing: false
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/sign/prepare/template/${_id}`)
  }

  getFields() {
    if (isMobile()) {
      return [
        {title: '', name: '_id', render: () => <GoFileText size={20} />},
        {
          title: 'Template',
          name: 'name'
        },
        {
          title: '',
          name: ' ',
          render: item => this.renderActions(item)
        }
      ]
    }
    return [
      {title: '', name: '_id', render: () => <GoFileText size={20} />},
      {
        title: 'Template',
        name: 'name'
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm'),
        defaultSort: 'DESC',
        sort: 'DESC'
      },
      {
        title: '',
        name: ' ',
        render: item => this.renderActions(item)
      }
    ]
  }

  renderActions(item) {
    return (
      <div>
        <span>
          <Actions options={this.renderOptions(item)} />
        </span>
      </div>
    )
  }

  renderOptions(item) {
    
    if (!this.props.organization) {
      return [this.renderCreateDocument(item), this.renderMassiveCreate(item)]
    } else if (this.props.organization && this.props.organization.myRole[0] !== 'member') {
      return [
        this.renderCreateDocument(item),
        this.renderMassiveCreate(item),
        this.renderDelete(item)
      ]
    } else {
      return [this.renderCreateDocument(item), this.renderMassiveCreate(item)]
    }
  }

  async deleteTemplate(item) {
    try {
      await this.props.deleteTemplate({
        templateId: item._id
      })
      this.props.showMessage('Deleted')
    } catch (e) {
    } finally {
      this.refs.paginated.reload()
    }
  }

  MdCancel
  MdLibraryBooks
  TiArrowForwardOutline

  renderCreateDocument(item) {
    return (
      <div onClick={() => this.createDocument(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdLibraryBooks size={20} />
            </div>
            <div className="col-xs-12 col-sm-9">Crear Documento</div>
          </div>
        </span>
      </div>
    )
  }

  renderDelete(item) {
    return (
      <div onClick={() => this.deleteTemplate(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdCancel size={20} style={{color: 'red'}} />
            </div>
            <div className="col-xs-12 col-sm-9">Eliminar Template</div>
          </div>
        </span>
      </div>
    )
  }

  renderMassiveCreate(item) {
    return (
      <div
        onClick={() => this.props.router.push(`/templates/massivecreate/${item._id}`)}
        style={{width: 200}}
      >
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <TiArrowForwardOutline size={20} />
            </div>
            <div className="col-xs-12 col-sm-9">Envío masivo</div>
          </div>
        </span>
      </div>
    )
  }

  async createDocument(item) {
    try {
      const doc = await this.props.createFromTemplate({
        templateId: item._id
      })
      this.props.router.push(`/documents/${doc.createFromTemplate._id}`)
      this.props.showMessage('Documento creado')
    } catch (error) {
      this.props.showMessage(error.message, {level: 'error'})
    } finally {
    }
  }

  renderButton() {
    const {showing} = this.state
    if (
      !this.props.organization ||
      (this.props.organization && this.props.organization.myRole[0] !== 'member')
    ) {
      return (
        <div className="row">
          <div className="col-xs-12 col-sm-3 start-sm col-md-3 col-lg-3">
            <Button primary to={'/templates/create'}>
              Crear Template
            </Button>
          </div>
          <div className="col-xs-12 col-sm-3 start-sm col-md-3 col-lg-3">
            <Button onClick={() => this.setState({showing: !showing})}>
              {showing ? <div>Volver</div> : <div>Instrucciones</div>}
            </Button>
          </div>
          {this.props.organization && this.props.organization.slug === 'securitysat' ? (
            <div className="col-xs-12 col-sm-6 start-sm col-md-6 col-lg-6">
              <Button
                className={styles.securitysat}
                onClick={() => this.props.router.push('/securitySatCustom')}
              >
                Operaciones SS
              </Button>
            </div>
          ) : null}
        </div>
      )
    }
  }

  renderSiteTemplates(){
    
      if(this.props.hasSiteTemplates && this.props.hasSiteTemplates.exist)
        return(
          <div>
            <h3 className={styles.title}>Templates Institucionales</h3>
            <div className="section">
                <div className="table">
                  <Paginated
                    loadingComponent={Loading}
                    queryName="siteTemplates"
                    onPress={this.onSelect}
                    fields={this.getFields()}
                    ref="paginated"
                    contextUrl={contextUrl}
                    params="$filter: String $organizationId: String $contextUrl: String"
                  />
                </div>
            </div>
          </div>
        )
  }

  render() {
    const {showing} = this.state
    return (
      <div>

        <div className={styles.container}>

          
          {this.renderSiteTemplates()}


          <div className="section">
            {showing ? (
              <div>
                <Instructions />
              </div>
            ) : (
              <div className="table">
                <Paginated
                  loadingComponent={Loading}
                  queryName="templates"
                  onPress={this.onSelect}
                  fields={this.getFields()}
                  ref="paginated"
                  organizationId={this.props.organization._id}
                  params="$filter: String $organizationId: String"
                />
              </div>
            )}
          </div>
          <div className={styles.buttons}>{this.renderButton()}</div>
        </div>

      </div>
      
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Templates/Main/index.js